import { jsx as _jsx } from "react/jsx-runtime";
import modalStyles, { useModalStyles } from './Modal.Styles';
import { Modal as ReactModal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { CrossIcon } from '../../icons';
export const Modal = ({ isOpen, onRequestClose, closeButton, children, showBorder, container, showBackdrop = false, ...props }) => {
    useModalStyles();
    return (_jsx(ReactModal, { open: isOpen, onClose: onRequestClose, showCloseIcon: !!closeButton, closeIcon: _jsx(CrossIcon, {}), styles: modalStyles(showBorder ?? true, showBackdrop), focusTrapped: false, center: true, container: container, ...props, children: children }));
};
export default Modal;
